import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface LoadingIconContainerProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element
    ariaValueText: string
    altText: string
}

const LoadingIconContainer = memo(({children, templating, ariaValueText, altText}: LoadingIconContainerProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName
                aria-valuetext={ariaValueText}
                aria-label={altText}
                data-testid="plp-results-loading-page-spinner"
                role="progressbar"
            >
                {children}
            </ComponentName>
        </Suspense>
    )
})
LoadingIconContainer.displayName = "LoadingIconContainer"

export default connect(LoadingIconContainer)
